import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { Button, Col, Modal, Row } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";

import { FacilityMasterApi } from "../../../api/backend/facilityMaster";
import kbn from "../../../api/backend/kbn";
import TitlePage from "../../../component/Desktop/titlePage";
import FooterPage from "../../../component/footer/footerPage";
import Overlay from "../../../component/Overlay/Overlay";
import SplitComponent from "../../../component/split-component/SplitComponent";
import {
  COMMON_CONSTANT,
  KEY,
  lang,
  MODE_SCREEN,
} from "../../../constants/common.const";
import { handleCatchError, showMessage } from "../../../constants/utils";
import classDdl from "../../../models/control/dropdownlist";
import classGrid from "../../../models/control/grid";
import classText from "../../../models/control/text";
import ListFacilityMaster from "./list";
import ViewFacilityMaster from "./view";
import Loading from "../../../component/Desktop/loading/loading";
import { isEmptyData } from "../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { setWidthModalColTable } from "../../../redux/sideBar";
import rolesConst from "../../../routers/roles/roles.const";

const FacilityMaster = () => {
  const facilityDataOrigin = {
    id: new classText(""),
    facilityName: new classText(""),
    processingAreaName: new classDdl(""),
    plantCode: new classDdl(""),
    facilityNumber: new classText(""),
    display: new classText(""),
  };
  const originDataInstance = () =>
    JSON.parse(JSON.stringify(facilityDataOrigin));
    
  const dispatch = useDispatch()
  const [facilityData, setFacilityData] = useState(originDataInstance());
  const [mode, setMode] = useState(MODE_SCREEN.VIEW);
  const [currentNode, setCurrentNode] = useState(null);
  const [optionPlant, setOptionPlant] = useState([]);
  const [optionArea, setOptionArea] = useState([]);
  const [loading,setLoading] = useState(false)
  const [isFillData,setIsFillData] = useState(false)
  const [firstNodeFilter, setFirstNodeFilter] = useState();
  const { collapsed } = useSelector((state) => state.sideBar);
  const [triggerWidth,setTriggerWidth] = useState(false)
  const [maxSize, setMaxSize] = useState(window.innerWidth - 400);
  const [editData,setEditData]  = useState(null);
  const [disabledEdit,setDisabledEdit] = useState(false)
  
  const {roles} = useSelector(state => state.auth)
  const isLead  = roles === rolesConst.HEAD_OFFICE_ADMIN 
  const inputRefs = useRef({});

  const [listData, setListData] = useState(new classGrid());
  const maxDisplay =
    listData.data.length > 0
      ? Math.max(...listData.data.map((item) => item.display || 0)) + 1
      : 1;
  const handleAdd = () => {
    setMode(MODE_SCREEN.ADD);
    const addData =originDataInstance()
    setFacilityData({...addData,plantCode:{
      ...addData.plantCode,
      value:"S"
    }});
    setFirstNodeFilter(null);
  };

  const handleEdit = () => {
    setMode(MODE_SCREEN.EDIT);
    setDisabledEdit(true);
    setEditData(JSON.parse(JSON.stringify(facilityData)))
  };
  useEffect(() => {
   if(mode === MODE_SCREEN.EDIT && editData){
    let isChange = false;
    Object.keys(editData).forEach(key => {
      if(editData[key].value != facilityData[key].value){
        isChange = true
      }
    })
    setDisabledEdit(!isChange)
   }
  },[mode,editData,facilityData])


  // CANCEL
  const onCancel = () => {
      setMode(MODE_SCREEN.VIEW);
      if (!currentNode || (currentNode && isEmptyData(currentNode.facilityCode))) {
        setFacilityData(originDataInstance())
        return;
      }
      getDetailFacility(currentNode.facilityCode);
      setIsFillData(false);
    };
    const handleCancel = () => {
      if (isFillData) {
        Modal.confirm({
          centered: true,
          icon: <QuestionCircleOutlined />,
          title: lang.CONFIRM,
          content: COMMON_CONSTANT.BOM_C018,
          okText: lang.OK,
          cancelText: lang.CANCEL,
          onOk: onCancel,
        });
      } else {
        onCancel();
      }
    };
  

  const showConfirmMessage = (
    msg,
    callbackOK,
    callbackCancel,
    typeInfo = false
  ) => {
    let ok, cancel;
    const callBackDefault = () => {
      Modal.destroyAll();
    };

    if (callbackOK) {
      ok = () => {
        callbackOK();
        callBackDefault();
      };
    }

    if (callbackCancel) {
      cancel = () => {
        callbackCancel();
        callBackDefault();
      };
    }

    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      centered: true,
      title: lang.CONFIRM,
      content: msg,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onCancel: cancel || callBackDefault,
      onOk: ok || callBackDefault,
    });
  };

  const validate = () => {
    let flagError = false;
    const dataCheck = { ...facilityData };
    let firstKey = "";
    const display = Number(dataCheck.display.value);
    const isEmptyDisplay =
      display === "" || display === null || display === undefined;
    if (isEmptyDisplay) {
      flagError = true;
      dataCheck.display.error = true;
      firstKey = "display";
    } else {
      dataCheck.display.error = false;
    }
    if (!String(dataCheck.facilityNumber.value).trim()) {
      flagError = true;
      dataCheck.facilityNumber.error = true;
      firstKey = "facilityNumber";
    } else {
      dataCheck.facilityNumber.error = false;
    }
    if (!String(dataCheck.plantCode.value).trim()) {
      flagError = true;
      dataCheck.plantCode.error = true;
      firstKey = "plantCode";
    } else {
      dataCheck.plantCode.error = false;
    }
    if ((isEmptyData(dataCheck.processingAreaName.value) || !String(dataCheck.processingAreaName.value).trim()) && Number(dataCheck.facilityNumber.value) < 50) {
      flagError = true;
      dataCheck.processingAreaName.error = true;
      firstKey = "processingAreaName";
    } else {
      dataCheck.processingAreaName.error = false;
    }

    if (!String(dataCheck.facilityName.value).trim()) {
      flagError = true;
      dataCheck.facilityName.error = true;
      firstKey = "facilityName";
    } else {
      dataCheck.facilityName.error = false;
    }

    if (!String(dataCheck.id.value).trim() && mode === MODE_SCREEN.EDIT) {
      flagError = true;
      dataCheck.id.error = true;
      firstKey = "id";
    } else {
      dataCheck.id.error = false;
    }

    if (
      firstKey &&
      inputRefs &&
      inputRefs.current &&
      inputRefs.current[firstKey]
    ) {
      inputRefs.current[firstKey].focus();
    }

    setFacilityData(dataCheck);
    return !flagError;
  };
  const handleAfterAddEdit = async (currentId) => {
    const listData = await getListData(currentId);
    if (!listData || !Array.isArray(listData)) {
      return;
    }
    const currentFacility = listData.find((i) => i.facilityCode == currentId);
    if (currentFacility) {
      onSelectList(currentFacility,true);
    }
  };
  const onSaveData = async () => {
    try {
      setLoading(true)
      const body = {
        facilityCode: facilityData.id.value,
        facilityName: facilityData.facilityName.value,
        processingArea: facilityData.processingAreaName.value,
        plantCode: facilityData.plantCode.value,
        facilityNumber: facilityData.facilityNumber.value,
        displayOrder: facilityData.display.value,
      };
      const res =
        mode === MODE_SCREEN.EDIT
          ? await FacilityMasterApi.updatefacilitymaster(body)
          : await FacilityMasterApi.createFacilityNew(body);
      showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, async () => {
        handleAfterAddEdit(res && res.data ? res.data : "");
      });
    } catch (error) {
      handleCatchError(error)
    }finally{
      setLoading(false)
    }
  };

  
    // DELETE
    const showMessageDeleteConfirm = () => {
      // Action del
      const funcDel = async () => {
        try {
          setLoading(true)
          await FacilityMasterApi.deleteFacilityNew(
            currentNode ? currentNode.facilityCode: ""
          );
          showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C004);
          setCurrentNode(null);
          setFacilityData(originDataInstance());
          getListData();
        } catch (error) {
          handleCatchError(error);
        } finally {
          setLoading(false);
        }
      };
  
      Modal.confirm({
        icon: <QuestionCircleOutlined />,
        title: lang.DELETE,
        content: COMMON_CONSTANT.BOM_C001,
        okText: lang.OK,
        cancelText: lang.CANCEL,
        onOk: funcDel,
        centered: true,
      });
    };
  const handleSave = () => {
    if (!validate()) {
      return;
    }
   showConfirmMessage(
         mode === MODE_SCREEN.ADD
           ? COMMON_CONSTANT.BOM_C008
           : COMMON_CONSTANT.BOM_C009,
         onSaveData
       );
  };
  // GET DETAIL
  const getDetailFacility = async (code) => {
    try {
      setLoading(true)
      const res = await FacilityMasterApi.getFacilityNewById(code);
      const dataDetail = res.data;
      const newDataFacility = { ...facilityData };
      newDataFacility.id.value = dataDetail.facilityCode;
      newDataFacility.facilityName.value = dataDetail.facilityName;
      newDataFacility.processingAreaName.value = dataDetail.processingArea;
      newDataFacility.processingAreaName.valueShow =
        dataDetail.areaName;
      newDataFacility.plantCode.value = dataDetail.plantCode;
      newDataFacility.plantCode.valueShow = dataDetail.plantName;
      newDataFacility.facilityNumber.value = dataDetail.facilityNumber;
      newDataFacility.display.value = dataDetail.displayOrder;
      Object.keys(newDataFacility).forEach(key => {
        newDataFacility[key].error = false
      })
      setFacilityData(newDataFacility);
    } catch (error) {
      handleCatchError(error);
    }finally{
      setLoading(false)
    }
  };

  const onSelectList = useCallback((node,isFetching) => {
    if(mode !== MODE_SCREEN.VIEW && !isFetching){
      return;
    }
    setCurrentNode(node);
    setMode(MODE_SCREEN.VIEW);
    const facilityCode = node ? node.facilityCode : "";
    getDetailFacility(facilityCode);
    setFirstNodeFilter(null);
  }, [mode]);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  // GET LIST DATA
  const getListData = async (idFocus) => {
    try {
      setLoading(true)
      const res = await FacilityMasterApi.getList();
      if (res && res.data) {
        setListData({ ...listData, data: res.data, count: res.data.length ,idFocus});
        return res.data
      }
    } catch (error) {
      handleCatchError(error);
    }finally{
      setLoading(false)
    }
  };
  useEffect(() => {
    getListData([]);
  }, []);

  // GET DATA INIT
  const getDataInit = async () => {
    try {
      const [resPlant, respArea] = await Promise.all([
        kbn.getListPlantCode(),
        kbn.getProcessArea(),
      ]);
      const dataPlant = resPlant.data.map(({ plantCode, plantName }) => ({
        key: plantCode,
        value: plantName,
      }));
      const dataArea = respArea.data.data;
      setOptionArea(dataArea);
      setOptionPlant(dataPlant);
    } catch (error) {
      handleCatchError(error);
    }
  };
  useEffect(() => {
    getDataInit();
  }, []);

   // Focus First Node filter
    useEffect(() => {
      if (firstNodeFilter && mode === MODE_SCREEN.VIEW) {
        onSelectList(firstNodeFilter);
      } else if (firstNodeFilter === undefined) {
        setCurrentNode(null)
        setFacilityData(originDataInstance())
      }
    }, [firstNodeFilter]);

    // GET WIDTH
    const divRef = useRef(null);
    useEffect(() => {
      if (divRef.current) {
        const width = divRef.current.getBoundingClientRect().width;
        dispatch(setWidthModalColTable({
          key : "facility",
          value: width
        }))
      }
    }, [collapsed,triggerWidth]);

    useEffect(() => {
        const handleResize = () => {
          setMaxSize(collapsed ? window.innerWidth - 200 : window.innerWidth - 300);
        };
    
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
    
      useEffect(() => {
        setMaxSize(collapsed ? window.innerWidth - 200 : window.innerWidth - 300);
      }, [collapsed]);
  return (
    <div className="des-content">
      <TitlePage name={lang.FACILITY_MASTER} />

      <div style={{ marginTop: 16 }}>
      <Overlay top={-28} />
        <SplitComponent minSize={40} maxSize={maxSize} onDragFinished={() => {
          setTriggerWidth(!triggerWidth)
        }} split="vertical" defaultSize="60%">
          {/* LEFT: List */}
          <div ref={divRef} className="equipment-tree-detail" style={{ paddingRight: 8 }}>
            <ListFacilityMaster
              currentNode={currentNode}
              setCurrentNode={onSelectList}
              listData={listData.data}
              idFocus={listData.idFocus}
              setFirstNodeFilter={setFirstNodeFilter}
              mode={mode}
            />
          </div>

          {/* RIGHT: View */}
          <div
            className="equipment-tree-detail"
            style={{ padding: 8, background: "#fff", height: "100%" }}
          >
            <ViewFacilityMaster
              facilityData={facilityData}
              setFacilityData={setFacilityData}
              currentNode={currentNode}
              mode={mode}
              inputRefs={inputRefs}
              optionArea={optionArea}
              optionPlant={optionPlant}
              setIsFillData={setIsFillData}
            />
          </div>
        </SplitComponent>
      </div>

      <FooterPage>
        {mode !== MODE_SCREEN.ADD && mode !== MODE_SCREEN.EDIT ? (
          <Row justify="end">
            <Col>
              <Button
                onClick={handleAdd}
                className="buttonPC button--info wAuto ml10"
              >
                <PlusOutlined />
                {lang.ADD}
              </Button>
            </Col>
            <Col>
              <Button
                disabled={!currentNode}
                onClick={handleEdit}
                className="buttonPC button--outline --todo-- wAuto ml15"
              >
                <EditOutlined />
                {lang.EDIT}
              </Button>
            </Col>
            <Col>
              <Button
                onClick={showMessageDeleteConfirm}
                disabled={!currentNode || !isLead}
                className={`buttonPC ${
                  (currentNode && isLead) ? " button--error--outline " : "button--outline"
                } ml15`}
              >
                <DeleteOutlined />
                {lang.DELETE}
              </Button>
            </Col>
          </Row>
        ) : (
          <Row justify="end">
            <Col>
              <Button
               disabled={mode == MODE_SCREEN.EDIT && disabledEdit}
                onClick={handleSave}
                className="buttonPC button--info wAuto ml10"
              >
                <SaveOutlined />
                {lang.SAVE}
              </Button>
            </Col>
            <Col>
              <Button
                onClick={handleCancel}
                className="buttonPC button--outline --todo-- wAuto ml15"
              >
                <CloseCircleOutlined />
                {lang.CANCEL}
              </Button>
            </Col>
          </Row>
        )}
      </FooterPage>
      <Loading show={loading} />
    </div>
  );
};

export default FacilityMaster;
